import type { NextPage } from 'next'

interface IProps {
  className?: string
  fill?: string
}

const Icon: NextPage<IProps> = ({className, fill}) => {
  const fillColor = fill || '#004097'
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="45" viewBox="0 0 18 45" className={className || ''}>
      <text id="_" data-name="+" transform="translate(0 35)" fill={fillColor} fontSize="30" fontFamily="NotoSansCJKkr-Bold, Noto Sans CJK KR" fontWeight="700" letterSpacing="-0.025em"><tspan x="0" y="0">+</tspan></text>
    </svg>
  )
}

export default Icon
